<template>
	<az-container class="az-container-mobile">
		<relatorio-painel-listagem-tabela
			:items="relatorios"
			@acessar-relatorio="acessarRelatorio"
		></relatorio-painel-listagem-tabela>
	</az-container>
</template>

<script>
import { actionTypes, routesNames } from '@/core/constants'
import RelatorioPainelListagemTabela from '@/views/pages/relatorios/painel/listagem/components/tabela/RelatorioPainelListagemTabela.vue'

export default {
	name: 'painel-listagem-view',
	components: { RelatorioPainelListagemTabela },
	data() {
		return {
			relatorios: [],
		}
	},
	async created() {
		await this.buscarListagem()
	},
	methods: {
		async acessarRelatorio(item) {
			await this.$router.push({
				name: routesNames.RELATORIO.PAINEL_VISUALIZACAO,
				query: {
					url: item.urlAcesso,
				},
			})
		},
		async buscarListagem() {
			const { itens } = await this.$store.dispatch(actionTypes.RELATORIOS.PAINEL.BUSCAR_LISTAGEM)
			if (itens.length === 1) {
				await this.acessarRelatorio(itens[0])
				return
			}

			this.relatorios = itens
		},
	},
}
</script>
<style scoped lang="stylus">
@media (max-width: 720px)
	.az-container-mobile
	&.az-container
		border-radius 0 !important
		margin 0 !important
</style>
